import { Link } from "react-router-dom";
import { useLang } from "../lib/i18n";
import { PRODUCT_ORDER } from "../lib/images";
import { Logo } from "./Logo";

export const Footer = () => {
  const { t } = useLang();
  const year = new Date().getFullYear();

  const navLinks = [
    { label: t.nav.home, to: "/" },
    { label: t.nav.projects, to: "/realisations" },
    { label: t.nav.primes, to: "/primes" },
    { label: t.nav.about, to: "/a-propos" },
    { label: t.nav.quote, to: "/rendez-vous" },
  ];

  const productLinks = PRODUCT_ORDER.map(({ key, slug }) => ({
    label: t.products[key].name,
    to: `/produits/${slug}`,
  }));

  return (
    <footer className="border-t border-white/10" data-testid="footer">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-4">
            <Logo className="h-[36px]" />
            <p className="mt-5 text-white/45 font-light max-w-xs text-sm leading-relaxed">{t.footer.tagline}</p>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.25em] text-white/35 mb-5">{t.nav.products}</p>
            <ul className="space-y-3">
              {productLinks.map((l, i) => (
                <li key={i}>
                  <Link to={l.to} data-testid={`footer-product-${i}`} className="line-hover text-sm text-white/65 hover:text-white transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="text-xs uppercase tracking-[0.25em] text-white/35 mb-5">{t.footer.nav}</p>
            <ul className="space-y-3">
              {navLinks.map((l, i) => (
                <li key={i}>
                  <Link to={l.to} data-testid={`footer-nav-${i}`} className="line-hover text-sm text-white/65 hover:text-white transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.25em] text-white/35 mb-5">{t.footer.contact}</p>
            <ul className="space-y-3 text-sm text-white/65">
              <li><a href="mailto:info@vplus.be" className="line-hover hover:text-white transition-colors">info@vplus.be</a></li>
              <li><a href="tel:+3225885600" className="line-hover hover:text-white transition-colors">02 588 56 00</a></li>
              <li className="text-white/40">Grimbergen · Belgique</li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between gap-4 mt-16 pt-8 border-t border-white/10 text-xs text-white/40 tracking-wide">
          <span className="flex flex-wrap items-center gap-x-3 gap-y-2">
            <span>© {year} COMEC BV · {t.footer.rights}</span>
            <Link to="/mentions-legales" data-testid="footer-legal" className="line-hover hover:text-white transition-colors">
              {t.footer.legal}
            </Link>
            <span className="text-white/20">·</span>
            <Link to="/politique-de-confidentialite" data-testid="footer-privacy" className="line-hover hover:text-white transition-colors">
              {t.footer.privacy}
            </Link>
          </span>
          <span className="flex items-center gap-4">
            <span>Made in Belgium</span>
            <Link
              to="/admin"
              data-testid="footer-admin-link"
              className="text-white/20 hover:text-accent-yellow transition-colors duration-300"
            >
              Admin
            </Link>
          </span>
        </div>
      </div>
    </footer>
  );
};
